export default class LoyaltyFeatures {
  constructor() {
    this.$el = document.querySelector(".js-loyalty-features");

    if (!this.$el) {
      return;
    }
  }
}
